import { render } from "./Staffs.vue?vue&type=template&id=e3abdd26&scoped=true"
import script from "./Staffs.vue?vue&type=script&lang=js"
export * from "./Staffs.vue?vue&type=script&lang=js"

import "./Staffs.vue?vue&type=style&index=0&id=e3abdd26&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3abdd26"]])

export default __exports__